import React, { useEffect, useState } from "react"
import { AddEditStatusForm } from "../forms/AddEditStatusForm"


export const OrganizationStatusModal = () => {
	return (
		<AddEditStatusForm/>
	)	
}


